<template>
  <div class="sign-live-counter" functional>
    <h3 class="sigin-title">{{ title || $t('host.k_593001') }}</h3>
    <p>{{ tip }}</p>
    <CountDown
      class="sign-live-counter-down"
      :duration="total"
      :consume="remaining"
      :redius="94"
    ></CountDown>
    <div class="sign-live-counter-end">
      <vh-button
        type="primary"
        round
        size="medium"
        class="sign-live-counter-end-btn"
        :disabled="cd > 0"
        @click="$emit('close-sign')"
      >
        {{ $t('host.k_593002') }}
        <span v-if="cd > 0">{{ cd }}s</span>
      </vh-button>
      <p>{{ $t('host.k_593003') }}</p>
    </div>
  </div>
</template>

<script>
  import CountDown from './countDown';
  export default {
    name: 'signinCounter',
    components: { CountDown },
    props: {
      total: {
        type: Number,
        default: 30
      },
      remaining: {
        type: Number,
        default: 0
      },
      autoSign: Boolean,
      title: String
    },
    computed: {
      cd() {
        return 10 - (this.total - this.remaining);
      },
      tip() {
        return this.autoSign ? this.$t('host.k_593004') : this.$t('host.k_593005');
      }
    }
  };
</script>

<style lang="less">
  .sign-live-counter {
    text-align: center;
    padding-top: 150px;
    &-down {
      margin: 0 auto;
    }
    > h3 {
      font-size: 14px;
      color: #1a1a1a;
      font-weight: 600;
      padding-bottom: 10px;
      &.sigin-title {
        padding-top: 20px;
      }
    }
    > p {
      font-size: 14px;
      color: #666;
    }
    &-end {
      position: relative;
      width: calc(100% - 60px);
      left: 30px;
      margin-top: 10px;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;

      &-btn {
        width: 160px;
        line-height: 20px;
        color: #fff;
      }
      > p {
        margin-top: 15px;
        font-size: 12px;
        color: #888;
      }
    }
  }
</style>
